import { Button, Label, TextInput, Select, Table, Modal } from "flowbite-react";
import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { IoMdClose } from "react-icons/io";
import Viewdetails from "../viewdetails";
import { IoMdDownload } from "react-icons/io";
import CustomSelectwithText from "../../../hooks/CustomSelectwithText";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSidebar } from "../../../context/SidebarOpenContext";
import axios from "axios";
import Breadcrumb from "../../../hooks/Breadcrumb";
import { RiInboxArchiveFill } from "react-icons/ri";
import useGeneratePDF from "../../../hooks/useGeneratePDF";
import Viewordercolordetails from "../view_order_color_details";
import { AuthContext } from "../../../context/AuthContext";
import { TbCircleLetterRFilled } from "react-icons/tb";
import { FaRectangleList } from "react-icons/fa6";
import RequestActivityModal from "../../../hooks/RequestActivityModal";

function AddCutting() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const Order_id = searchParams.get("orderid");
    const Sub_Order_id = searchParams.get("sid");
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [Order, setOrder] = useState({ sizevarientwithquantity: "", buyer_name: "", colour_name: "", style_name: "", orderdate: "", total_piece: 0, cutorderno: "", pono: "", noofbales: "", delivery_date: "" });
    const [Suborder, setSuborder] = useState({});
    const [Suborderr, setSuborderr] = useState({ sizevarientwithquantity: "", total_piece: 0 })
    const [Marker, setMarker] = useState({});
    const [Initial_cut_order_no, setInitial_cut_order_no] = useState();
    const [Cutrows, setCutrows] = useState([{ cutting_log_Id: "", cuttingNo: Initial_cut_order_no, layerLen: "", noLayers: "", sizevariant: {}, totalvariant: 0, totalpiece: 0, totalFabric: 0, Avgcmp: 0 }]);
    const { user } = useContext(AuthContext);
    const role = sessionStorage.getItem('role');
    const [requestModal, setrequestModal] = useState(false);
    const [requestActivityModal, setrequestActivityModal] = useState(false);
    const [requestActivityData, setrequestActivityData] = useState({});
    const [Input, setInput] = useState({});


    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {
            // fetchorder();
        }
    }, [user, navigate]);
    useEffect(() => {
        fetchorder();
        fetchsuborder();
        fetchsuborderr();
        fetchmarker();
        fetchCutting();
    }, []);

    const onChangeValue = (e) => {
        setInput({ ...Input, [e.target.name]: e.target.value });
    };

    const fetchrequestActivity = async (rtsId) => {
        try {
            const response = await axios.get(`/requests/request/${rtsId}`, {
                params: { section_name: 'Cutting' },
            });
            const requestActivityData = response.data.data;
            // console.log(requestActivityData)
            setrequestActivityData(requestActivityData);
        } catch (error) {
            console.error("Error fetching requestActivityData:", error);
        }
    };

    const handleRequest = async (e) => {
        e.preventDefault();

        setrequestModal(false)
        const requestData = {
            ...Input,
            order_id: Order_id,
            sub_order_id: Sub_Order_id,
            staff_id: user.staff_id,
            section_name: 'Cutting',
            section_id: Input.id,
            reason: Input.reason
        };
        try {
            axios
                .post('cutting/request', requestData)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Requested",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        fetchCutting();
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }
    };

    const fetchorder = async () => {
        try {
            const response = await axios.get(`order/orders/${Order_id}`);
            const OrderData = response.data;
            setOrder({
                orderdate: OrderData.order_date,
                total_piece: OrderData.total_piece,
                cutorderno: OrderData.cut_order_no,
                pono: OrderData.job_no,
                noofbales: OrderData.no_of_bales,
                buyer_name: OrderData.buyer_name,
                colour_name: OrderData.colour_name,
                style_name: OrderData.style_name,
                delivery_date: OrderData.delivery_date,
                sizevarientwithquantity: OrderData.size_variant_quantity,
            });

        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    };
    const fetchsuborder = async () => {
        try {
            const response = await axios.get(`order/suborders_by_suborder_id/${Sub_Order_id}`);
            const SubOrderData = response.data.suborder;
            setSuborder(SubOrderData);


        } catch (error) {
            console.error("Error fetching suborder data:", error);
        }
    };
    const fetchCutting = async () => {
        try {
            const response = await axios.get(`cutting/cuttings/${Order_id}/${Sub_Order_id}`);
            const orderData = response.data;
            if (orderData.success == 2) {

                setCutrows((prevCutrows) => [{
                    ...prevCutrows[0],
                    cuttingNo: orderData.Initial_cutting_no,
                    // staff_id:user.staff_id
                }]);
                setInitial_cut_order_no(orderData.Initial_cutting_no)
            }
            else {
                setCutrows(orderData.cutting_plan);
                setInitial_cut_order_no(orderData.Initial_cutting_no)
            }
        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    };
    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/size_variants");
            const markerData = response.data;
            setMarker(markerData);
            // console.log(Marker)
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };
    const fetchsuborderr = async () => {
        try {
            const response = await axios.get(`order/suborders_by_suborder_id_size_variant/${Sub_Order_id}`);
            const SubOrderData = response.data;
            //   setSuborder(SubOrderData);
            setSuborderr({
                sizevarientwithquantity: SubOrderData.size_variant_quantity,
                total_piece: SubOrderData.total_piece,
            })

        } catch (error) {
            console.error("Error fetching suborder data:", error);
        }
    };
    const sizevariantOptions = Marker.length > 0 ? Marker
        .filter((item) => Suborderr.sizevarientwithquantity[item.size_id] != undefined)
        .map((item) => ({
            value: item.size_id,
            label: item.size
        })) : [];
    const addCutting = async () => {

        if (grandTotal > 0) {
            const size_variant_quantity = sizevariantOptions.reduce((acc, option) => {
                acc[option.value] = totalQuantities[option.label] || 0;
                return acc;
            }, {});

            axios.post(`cutting/validation_order_percentage`, {
                order_id: Order_id,
                suborder_id: Sub_Order_id,
                total_piece: parseInt(grandTotal),
                size_variant_quantity: size_variant_quantity
            })
                .then((res) => {
                    if (res.data.status === 1) {
                        Swal.fire({
                            icon: "error",
                            text: "Cutting quantity exceeds the order quantity ",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });

                    } else {

                        try {
                            axios
                                .post(`cutting/cuttings`, {
                                    order_id: Order_id,
                                    suborder_id: Sub_Order_id,
                                    cut_order_no: Order.cutorderno,
                                    size_variant_quantity: size_variant_quantity,
                                    total_piece: parseInt(grandTotal),
                                    cuttingplan: Cutrows,
                                    staff_id: user.staff_id,
                                })
                                .then((res) => {
                                    if (res.data.success === 1) {
                                        Swal.fire({
                                            icon: "success",
                                            text: "Cutting details updated..",
                                            type: "success",
                                            timer: 2000,
                                            showConfirmButton: false,
                                        });
                                        navigate(`/view_sub_order_details?id=${Order_id}&sid=${Sub_Order_id}`);

                                    }
                                    else if (res.data.success === 2) {
                                        Swal.fire({
                                            icon: "error",
                                            text: "Please fill the values...",
                                            type: "error",
                                            timer: 2000,
                                            showConfirmButton: false,
                                        });
                                    }
                                    else {
                                        Swal.fire({
                                            icon: "error",
                                            text: "Server Problem. Please Try Again...",
                                            type: "error",
                                            timer: 2000,
                                            showConfirmButton: false,
                                        });
                                    }
                                    return;
                                });
                        } catch (error) {
                            throw error;
                        }

                    }
                    return;
                });
        }
        else {

            Swal.fire({
                icon: "error",
                text: "Please fill the values",
                type: "error",
                timer: 2000,
                showConfirmButton: false,
            });

        }





    };
    const getNextCuttingNo = (currentRows) => {
        if (currentRows.length === 0) return Initial_cut_order_no;

        const lastCuttingNo = currentRows[currentRows.length - 1].cuttingNo;

        // Extract parts: "26" (baseNumber), "A" (alphabeticPart), "2" (colorid)
        const baseNumber = lastCuttingNo.match(/^\d+/)[0]; // Matches numeric part at the start
        const alphabeticPart = lastCuttingNo.match(/[A-Z]+/)[0]; // Matches the alphabetic part
        const colorid = lastCuttingNo.match(/\d+$/)[0]; // Matches numeric part at the end

        let nextAlphabeticPart = alphabeticPart;

        // Increment logic for alphabetic part: "A" → "B", "Z" → "AA", etc.
        const increment = (str) => {
            let carry = true;
            const chars = str.split("").reverse();
            for (let i = 0; i < chars.length; i++) {
                if (!carry) break;
                const nextChar = String.fromCharCode(chars[i].charCodeAt(0) + 1);
                if (nextChar > "Z") {
                    chars[i] = "A";
                } else {
                    chars[i] = nextChar;
                    carry = false;
                }
            }
            if (carry) chars.push("A");
            return chars.reverse().join("");
        };

        nextAlphabeticPart = increment(alphabeticPart);

        return `${baseNumber}${nextAlphabeticPart}${colorid}`;
    };
    const handleCutInputChange = (index, field, value) => {
        const currentDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
        const rowDate = Cutrows[index]?.datatime
            ? new Date(Cutrows[index].datatime).toISOString().split("T")[0]
            : null;

        const isNewRow = !Cutrows[index]?.cutting_log_Id; // New rows don't have an ID
        const canEditSizeVariant = isNewRow || currentDate === rowDate;

        // Prevent `sizevariant` change if it's a past row
        if (field === "sizevariant" && !canEditSizeVariant) {
            console.warn(`Editing sizevariant is disabled for this row: ${index}`);
            return;
        }

        // Update the row data
        const newRows = Cutrows.map((row, i) => {
            if (i === index) {
                const updatedRow = { ...row, [field]: value };

                if (field === "sizevariant") {
                    const totalVariant = Object.values(value)
                        .map(Number)
                        .reduce((acc, val) => acc + val, 0);
                    updatedRow.totalvariant = totalVariant;
                }

                if (field === "noLayers" || field === "layerLen") {
                    updatedRow.totalFabric = parseFloat(updatedRow.noLayers * updatedRow.layerLen).toFixed(2);
                    updatedRow.Avgcmp = updatedRow.totalpiece > 0
                        ? parseFloat(updatedRow.totalFabric / updatedRow.totalpiece).toFixed(2)
                        : 0;
                }

                if (field === "noLayers" || field === "sizevariant") {
                    updatedRow.totalpiece = updatedRow.totalvariant * updatedRow.noLayers;
                    updatedRow.Avgcmp = updatedRow.totalpiece > 0
                        ? parseFloat(updatedRow.totalFabric / updatedRow.totalpiece).toFixed(2)
                        : 0;
                }

                return updatedRow;
            }
            return row;
        });

        setCutrows(newRows);
    };
    const handleDeleteCutRow = (index) => {
        const updatedRows = Cutrows.filter((_, i) => i !== index).map((row, idx) => ({
            ...row,
            cuttingNo: `${getNextCuttingNo(Cutrows.slice(0, idx))}`,
        }));
        setCutrows(updatedRows);
    };
    const handleAddCutRow = () => {
        const nextCuttingNo = getNextCuttingNo(Cutrows);
        const newRow = { cutting_log_Id: "", cuttingNo: nextCuttingNo, layerLen: "", noLayers: "", sizevariant: [], totalvariant: 0, totalpiece: 0, totalFabric: 0, Avgcmp: 0 };
        setCutrows([...Cutrows, newRow]);
    };
    const totalQuantities = sizevariantOptions.reduce((acc, option) => {
        acc[option.label] = 0;
        return acc;
    }, {});
    Cutrows.forEach((row) => {
        const singleQuantity = row.totalpiece / (row.totalvariant || 1);
        Object.keys(row.sizevariant).forEach((variantId) => {
            const variantLabel = sizevariantOptions.find((option) => option.value == variantId)?.label;
            if (variantLabel) {
                if (!totalQuantities[variantLabel]) {
                    totalQuantities[variantLabel] = 0;
                }
                totalQuantities[variantLabel] += singleQuantity * Number(row.sizevariant[variantId]);
            }
        });
    });
    const grandTotal = Object.values(totalQuantities).reduce(
        (sum, qty) => sum + qty,
        0
    );
    const handleGeneratePDF = useGeneratePDF(Order, Marker, Cutrows, sizevariantOptions, totalQuantities, grandTotal, Suborder);
    const breadcrumbItems = [
        {
            href: "/order",
            label: "Order",
            icon: (
                <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5  " />
            ),
        },
        {
            href: `/view_order_details?id=${Order_id}`,
            label: "View Order",
            icon: (
                <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5  " />
            ),
        },
        {
            href: `/view_sub_order_details?id=${Order_id}&sid=${Sub_Order_id}`,
            label: "Color-Based Order View",
            icon: (
                <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5  " />
            ),
        },
        {
            label: "Cutting Details",
        },

    ];

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700  mt-14  h-full">
                <div className="p-4 rounded-lg shadow bg-white ">
                    <div className="space-y-6">
                        <Breadcrumb items={breadcrumbItems} />
                        <Viewdetails orderid={Order_id} />
                        <Viewordercolordetails Sub_Order_id={Sub_Order_id} />
                        <div className=" flex items-center ">
                            <h3 className="text-xl font-medium text-sidebar-color dark:text-white mr-2">
                                Cutting Details
                            </h3>
                            <Button className="bg-sidebar-color text-white" size="xs" onClick={handleGeneratePDF}> <IoMdDownload className="mr-1" />  Download PDF</Button>
                        </div>
                        <div className="overflow-x-auto "  >
                            <Table hoverable className="border">
                                <Table.Head className="border">
                                    <Table.HeadCell className="border min-w-[80px]">Cutting No</Table.HeadCell>
                                    <Table.HeadCell className="border min-w-[100px] w-[200px]">Layer Length</Table.HeadCell>
                                    <Table.HeadCell className="border min-w-[100px] w-[200px]">No. of Layers</Table.HeadCell>
                                    <Table.HeadCell className="border min-w-[200px] w-[250px]">Marker</Table.HeadCell>
                                    <Table.HeadCell className="border min-w-[80px]">Total Marker</Table.HeadCell>
                                    <Table.HeadCell className="border min-w-[80px]">Total Piece</Table.HeadCell>
                                    <Table.HeadCell className="border min-w-[80px]">Total Fabric</Table.HeadCell>
                                    <Table.HeadCell className="border min-w-[100px]">Avg CMP Per GMT</Table.HeadCell>
                                    <Table.HeadCell className="border min-w-[50px]">Option</Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="divide-y border">
                                    {Cutrows.map((row, index) => {
                                        const currentDate = new Date().toISOString().split("T")[0];
                                        const rowDate = row.datatime ? new Date(row.datatime).toISOString().split("T")[0] : null;

                                        const isNewRow = !row.cutting_log_Id;
                                        const canEdit = role === "super_admin" || isNewRow || ((role === 'Cutting_Staff' || role === 'FM') && currentDate === rowDate) || ((role === 'FM' && row.request_status == 'accepted'));


                                        return (
                                            <Table.Row key={index} className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer">
                                                <Table.Cell className="border">{row.cuttingNo}</Table.Cell>
                                                <Table.Cell className="border">
                                                    <TextInput
                                                        name={`layerLen-${index}`}
                                                        type="text"
                                                        min="1"
                                                        required
                                                        autoComplete="off"
                                                        value={row.layerLen}
                                                        onChange={(e) => handleCutInputChange(index, "layerLen", e.target.value)}
                                                        disabled={!canEdit}
                                                        className={!canEdit ? "cursor-not-allowed" : ""}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "."];

                                                            // Allow digits and allowed keys
                                                            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                                                                e.preventDefault();
                                                            }

                                                            const val = String(row.layerLen || ""); // convert to string safely

                                                            // Prevent typing more than one decimal
                                                            if (e.key === "." && val.includes(".")) {
                                                                e.preventDefault();
                                                            }
                                                        }}


                                                    />
                                                </Table.Cell>
                                                <Table.Cell className="border">
                                                    <TextInput
                                                        name={`noLayers-${index}`}
                                                        type="text"
                                                        min="1"
                                                        required
                                                        autoComplete="off"
                                                        value={row.noLayers}
                                                        onChange={(e) => handleCutInputChange(index, "noLayers", e.target.value)}
                                                        disabled={!canEdit}
                                                        className={!canEdit ? "cursor-not-allowed" : ""}
                                                        onKeyDown={(e) => {
                                                            if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                                                                e.preventDefault();
                                                            }
                                                        }}

                                                    />
                                                </Table.Cell>
                                                <Table.Cell className="border">
                                                    <CustomSelectwithText
                                                        value={row.sizevariant}
                                                        onChange={(selectedOptions) => handleCutInputChange(index, "sizevariant", selectedOptions)}
                                                        options={sizevariantOptions}
                                                        id="size-variant-select"
                                                        name="sizeVariant"
                                                        isDisabled={!canEdit}
                                                        style={{
                                                            cursor: !canEdit ? "not-allowed" : "default",
                                                        }}
                                                    />
                                                </Table.Cell>

                                                <Table.Cell className="border">{row.totalvariant}</Table.Cell>
                                                <Table.Cell className="border">{row.totalpiece}</Table.Cell>
                                                <Table.Cell className="border">{row.totalFabric}</Table.Cell>
                                                <Table.Cell className="border">{row.Avgcmp}</Table.Cell>
                                                <Table.Cell className="border">

                                                    <div style={{ display: "flex" }}>
                                                        <IoMdClose
                                                            size={24}
                                                            style={{
                                                                color: (Cutrows.length === 1 || !canEdit) ? "grey" : "red",
                                                                cursor: (Cutrows.length === 1 || !canEdit) ? "not-allowed" : "pointer",
                                                            }}
                                                            onClick={(Cutrows.length === 1 || !canEdit) ? null : () => handleDeleteCutRow(index)}
                                                        />

                                                        {(role === 'FM' && currentDate !== rowDate && row.request_status != 'accepted') && (
                                                            <TbCircleLetterRFilled
                                                                className="text-green-500 text-xl cursor-pointer"
                                                                onClick={() => {
                                                                    (row.request_status == 'request' || row.request_status == "rejected") && setrequestModal(true); setInput({ id: row.cutting_log_Id });

                                                                }}
                                                                style={{
                                                                    color: row.request_status == 'requested' ? "grey" : "green",
                                                                    cursor: row.request_status == 'requested' ? "not-allowed" : "pointer",
                                                                }}
                                                            />
                                                        )}
                                                        {(role === 'FM' || role === 'super_admin') &&
                                                            <FaRectangleList
                                                                className="pl-1 text-blue-500 text-2xl cursor-pointer"
                                                                onClick={() => {
                                                                    fetchrequestActivity(row.cutting_log_Id);
                                                                    setrequestActivityModal(true);

                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })}
                                </Table.Body>
                            </Table>



                            <div className="overflow-x-auto pt-4" >
                                <Table className="border" >
                                    <Table.Head className="border">
                                        <Table.HeadCell className="border">Size</Table.HeadCell>
                                        {sizevariantOptions.map((option) => (
                                            <Table.HeadCell key={option.value} className="border">
                                                {option.label}
                                            </Table.HeadCell>
                                        ))}
                                        <Table.HeadCell className="border">Total</Table.HeadCell>
                                    </Table.Head>
                                    <Table.Body className="divide-y">
                                        <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                            <Table.Cell className="border whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                                Quantity
                                            </Table.Cell>
                                            {sizevariantOptions.map((option) => (
                                                <Table.Cell key={option.value} className="border">
                                                    {totalQuantities[option.label]}
                                                </Table.Cell>
                                            ))}
                                            <Table.Cell className="border">{parseInt(grandTotal)}</Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                            </div>
                        </div>
                        <div className="flex justify-center gap-4"  >
                            <Button className="bg-sidebar-color text-white" onClick={handleAddCutRow}  >    {"Add"}</Button>
                            <Button className=" bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="button" onClick={() => addCutting()} > {"Submit"}  </Button>

                        </div>

                    </div>


                    <Modal
                        show={requestModal}
                        size="md"
                        onClose={() => setrequestModal(false)}
                        popup
                    >
                        <Modal.Header />
                        <Modal.Body>
                            <div className="text-center">
                                <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                                    Are you sure you want to request admin access for editing?
                                </h3>

                            </div>
                            <div className="space-y-6">

                                <form>
                                    <div>
                                        <div className="pt-2 text-left mb-2 block">
                                            <Label htmlFor="completed-date" value="Reason" />
                                        </div>
                                        <TextInput
                                            id="reason"
                                            name="reason"
                                            type="text"
                                            required
                                            autoComplete="off"
                                            onChange={onChangeValue}
                                        />
                                    </div>

                                    <div className="pt-3 w-full flex justify-center">
                                        <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit" onClick={(e) => handleRequest(e)}>
                                            Yes
                                        </Button>
                                        <Button className="ml-2" color="gray" onClick={() => setrequestModal(false)}>
                                            No
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <RequestActivityModal
                        show={requestActivityModal}
                        onClose={() => setrequestActivityModal(false)}
                        requestActivityData={requestActivityData}
                    />
                </div>
            </div>
        </div>
    );
}

export default AddCutting;
